export interface NavItem {
  /** Route key. */
  id: string;
  /** Lucide icon name. */
  icon: string;
  label: string;
  /** Optional count badge (e.g. comprobantes pendientes). */
  badge?: number;
  /** Ruta href (para React Router). Opcional: el shell puede usar id + onNav en su lugar. */
  to?: string;
}

// Nav del portal negocio. El label de "clientes" se re-etiqueta por vertical en runtime
// (ver terminologyOf). Aquí va el genérico.
export const PORTAL_NAV: NavItem[] = [
  { id: 'dashboard', icon: 'layout-dashboard', label: 'Dashboard', to: '/app' },
  { id: 'clientes', icon: 'users', label: 'Clientes', to: '/app/clientes' },
  { id: 'planes', icon: 'layers', label: 'Planes', to: '/app/planes' },
  { id: 'cobros', icon: 'receipt', label: 'Cobros', to: '/app/cobros' },
  { id: 'comprobantes', icon: 'image', label: 'Comprobantes', to: '/app/comprobantes' },
  { id: 'ingresos', icon: 'bar-chart-3', label: 'Ingresos', to: '/app/ingresos' },
  { id: 'reportes', icon: 'file-text', label: 'Reportes', to: '/app/reportes' },
  { id: 'referidos', icon: 'gift', label: 'Referidos', to: '/app/referidos' },
  { id: 'config', icon: 'settings', label: 'Configuración', to: '/app/config' },
];

// Nav del portal cliente (mobile-first, bottom tabs).
export const CLIENT_NAV: NavItem[] = [
  { id: 'inicio', icon: 'home', label: 'Inicio', to: '/app' },
  { id: 'pagos', icon: 'receipt', label: 'Pagos', to: '/app/pagos' },
  { id: 'perfil', icon: 'user', label: 'Perfil', to: '/app/perfil' },
];

// Nav del panel admin plataforma.
export const ADMIN_NAV: NavItem[] = [
  { id: 'resumen', icon: 'gauge', label: 'Resumen', to: '/' },
  { id: 'negocios', icon: 'store', label: 'Negocios', to: '/negocios' },
  { id: 'suscripciones', icon: 'credit-card', label: 'Suscripciones', to: '/suscripciones' },
  { id: 'solicitudes', icon: 'inbox', label: 'Solicitudes', to: '/solicitudes' },
  { id: 'referidos', icon: 'gift', label: 'Referidos', to: '/referidos' },
  { id: 'config', icon: 'settings', label: 'Configuración', to: '/config' },
];

export const ADMIN_PURPLE = '#8B5CF6';
export const ADMIN_PURPLE_SOFT = 'rgba(139,92,246,.16)';
